// module name "shared" is the name of the dependency to require in angular,
// factory name "shared" is the name to require in controller/directives.
let shared = angular.module('shared', [ ]).factory('shared', [ '$timeout', function($timeout) {
	let customChangeEvent = new CustomEvent('change', {});
	let toHandle = undefined;

	return {
		/**
		 * Takes in a form data JSON object and a 
		 * list of required values.
		 * Loops over the required list and checks whether or not any required value is not set inside list.
		 * 
		 * @param	JSON	formData	The form data to check
		 * @param	Array	req			The list of required keys inside formData
		 * @return	mixed				True if valid input, an array with missing keys
		 */
		validInput: (formData, req) => {
			let missing = [];
			req.forEach(key => {
				if (typeof(formData[key]) === 'undefined' 
					|| formData[key] === undefined 
					|| formData[key] === null 
					|| formData[key] === 0
					|| formData[key] === ''
					|| formData[key] === false) {
						missing.push(key);
				}
			});

			return missing.length > 0 ? missing : true;
		},
		/**
		 * Tries to load __PREPOPULATE specific data to use as initial input data.
		 * 
		 * @param	string	ctrl	The name of the controller, used as subkey for prePopulate data
		 * @param	Array	keys	An array of keys to fetch.
		 * @return	mixed			boolean false if nothing to prePopulate, otherwise an array with key->value.
		 */
		populate: (ctx, ctrl, keys) => {
			if (typeof(__PREPOPULATE) === 'undefined' || typeof(__PREPOPULATE[ctrl]) === 'undefined') {
				return false;
			}

			let result = {};
			keys.forEach(key => {
				if (typeof(__PREPOPULATE[ctrl][key]) !== 'undefined' && __PREPOPULATE[ctrl][key] != null) {
					$timeout(() => ctx.form[key] = __PREPOPULATE[ctrl][key], 0);
				}
			});

			if (toHandle) { toHandle = $timeout.cancel(toHandle); }
			// trigger materialdesign effect, save in handle to avoid firing it for each step
			//! Make sure to only trigger for some inputs, 
			//! not all or it will convert undefined values to empty string in controllers that were not displayed yet,
			//! greeting the user with error message as soon as they enter the page.
			toHandle = $timeout(() => {
				let inputs = Array.prototype.slice.call(document.querySelectorAll('input'));
				inputs.forEach(inp => {
					if (inp.value.length > 0) {
						inp.dispatchEvent(customChangeEvent);
					}
				});
			}, 100);  // ng must render the values into the UI

			return result;
		},
		getPopValueByKey: key => typeof(__PREPOPULATE) !== 'undefined' && __PREPOPULATE[key] !== null && __PREPOPULATE[key] || undefined,
		getDeathBenefit: creditSum => Math.floor(Math.min(110000, creditSum)),
		getIncidentBonus: monthlyRate => Math.floor(Math.min(5000, monthlyRate*2)),
		getWorkRelatedBenefit: monthlyRate => Math.floor(Math.min(2500, monthlyRate)),
		formatAsNumber: inp => {
			let _i = inp.toString().replace(/\D/g, '');

			return parseFloat(_i).toFixed(2).replace(',', '.').replace(/\d{3}(?=(\d{3})*\.)/g, function (s) { return '.' + s }).replace(/^\.|^,|\.00$/g, '');
		}
	};
}]);

(function() {
	if (typeof define === 'function' && define.amd)
		define('shared', function () { return shared; });
	else if (typeof module !== 'undefined' && module.exports)
		module.exports = shared;
	else
		window.shared = shared;
})();